import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class LanguageGuard implements CanActivate {
  private allowedLanguages = ['es', 'en'];
  constructor(private router: Router) {}

  canActivate(): boolean {
    const baseHref = document
      .getElementsByTagName('base')[0]
      .getAttribute('href')
      ?.replaceAll('/', '');
    console.log(baseHref);

    // if (this.allowedLanguages.includes(baseHref || '')) {
    //   return true;
    // }

    if (baseHref === 'de') {
      this.router.navigate(['/scubamedic']);
      return false;
    }

    return true;
  }
}
